export default {
  setStreetNameOptions: (state, streetNameOptions) => {
    state.propertyAddress.streetNameOptions =
      streetNameOptions &&
      streetNameOptions.map(item => {
        return { id: item.ADDR2, label: item.ADDR1 };
      });
  },
  setAddressDetails: (state, response) => {
    if (response.Success) {
      state.propertyAddress.validatedAddress = response;
      state.propertyAddress.validatedAddress.cityPinOptions =
        response.PINs?.map(pin => {
          return { id: pin, label: pin };
        });
      state.propertyAddress.isStreetNameValid = response.Success;
    } else {
      state.propertyAddress.isStreetNameValid = response.Success;
    }
  },
  setEstimate: (state, response) => {
    state.estimateDetails = response;
  },
  setValue: (state, response) => {
    if (response) {
      if (typeof response.value === "object") {
        state[response.key] = { ...response.value };
      } else {
        state[response.key] = response.value;
      }
    }
  },
  setErrors: (state, error) => {
    state.errors = { ...state.errors, ...error };
  }
};
